/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {
    $Sprite,
} from '@gongxigames/framework/core/fragments/BuilderY';
import {LSViewConfig} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/loadingScreenViewConfig';
import {getOrientation} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/utils/getOrientation';
import {$Slides} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/components/slides/Slides';
import {SlidesComponents, SlidesComponentsProps} from '@gongxigames/framework/slotV2/modules/loadingScreenV2/types';

const getSlides = (): ReturnType<typeof $Sprite>[] => {
    return LSViewConfig.sliderImagesList.map(slideName => {
        return (<$Sprite anchor={0.5} texture={slideName} />);
    });
};

export const renderSlides = (slidesComponents: SlidesComponents) => {

    return <$Slides
        slidesComponents={slidesComponents}
        reactiveSlidesScale={getOrientation(LSViewConfig.slidesParams.scale)}
        slidesPosition={getOrientation(LSViewConfig.slidesParams.position)}
        arrowsPosition={getOrientation(LSViewConfig.arrowButtonParams.position)}
        dotsPosition={getOrientation(LSViewConfig.dotButtonParams.position)}
        textPosition={getOrientation(LSViewConfig.textFeatureDescription.position)}
        hitAreaArrows={LSViewConfig.slidesParams.hitAreaArrows}
        hitAreaDots={LSViewConfig.slidesParams.hitAreaDots}
        dotsHide={!!LSViewConfig.slidesParams.dotsHide}
        autoSlideTime={LSViewConfig.slidesParams.autoSlideTime}
        defaultSlideTime={LSViewConfig.slidesParams.defaultSlideTime}
        arrowsHide={LSViewConfig.sliderImagesList.length <= 0}
    >
        {getSlides()}
    </$Slides>;
};